import script from "./HomeCustomerSort.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCustomerSort.vue?vue&type=script&setup=true&lang=js"

import "./HomeCustomerSort.vue?vue&type=style&index=0&id=41697480&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41697480"]])

export default __exports__